import { OverlayScreen } from './OverlayScreen';
import { PairedScreen } from './PairedScreen';
import { PairingScreen } from './PairingScreen';
import { PreviewEngineScreen } from './widget-engine/PreviewEngineScreen';
import { useDisplayStore } from './store';

export default function App() {
  // Public broadcast overlay route — bypasses pairing/auth, talks to the
  // backend with an overlay token instead of a display token.
  if (window.location.pathname.startsWith('/overlay/')) {
    return <OverlayScreen />;
  }
  // Widget-engine preview harness (Phase 2 dev route).
  if (window.location.pathname.startsWith('/preview-engine')) {
    return <PreviewEngineScreen />;
  }
  const token = useDisplayStore((s) => s.displayToken);
  return token ? <PairedScreen /> : <PairingScreen />;
}
